const UserActionTypes = {
    ADD_OTHER: "ADD_OTHER",
    ADD_USERS: "ADD_USERS",
    SET_EMAIL: "SET_EMAIL",
    SET_SELF: "SET_SELF",
};

export default UserActionTypes;